// DataSheetPDF.jsx
import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

// Create styles for your data sheet layout
const styles = StyleSheet.create({
  page: { padding: 30, backgroundColor: '#ffffff' },
  title: { fontSize: 24, marginBottom: 20, textAlign: 'center', fontWeight: 'bold' },
  table: { display: 'table', width: '100%', borderStyle: 'solid', borderWidth: 1, borderRightWidth: 0, borderBottomWidth: 0 },
  tableRow: { margin: 'auto', flexDirection: 'row' },
  tableColHeader: { width: '20%', borderStyle: 'solid', borderWidth: 0, borderLeftWidth: 0, borderTopWidth: 0, backgroundColor: '#f0f0f0', padding: 5 },
  tableCol: { width: '20%', borderStyle: 'solid', borderWidth: 1, borderLeftWidth: 0, borderTopWidth: 0, padding: 5 },
  tableCellHeader: { fontSize: 12, fontWeight: 'bold' },
  tableCell: { fontSize: 10 }
});

export const DataSheetPDF = ({ data, fileName }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <Text style={styles.title}>LEADWAY PFA</Text>
      <Text style={styles.title}> {fileName} </Text>
      
      {/* Dynamic Table Generation */}
      <View style={styles.table}>
        {/* Table Header */}
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Date</Text></View>
          <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Bonds</Text></View>
          <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Cash</Text></View>
          <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Equity</Text></View>
          <View style={styles.tableColHeader}><Text style={styles.tableCellHeader}>Money Market</Text></View>
        </View>
        
        {/* Table Rows */}
        {data.map((item) => (
          <View style={styles.tableRow} key={item.id}>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{item.date}</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{item.bond}</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{item.cash}</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{item.equity}</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{item.moneyMarket}</Text></View>
          </View>
        ))}
      </View>
    </Page>
  </Document>
);